export default function ZipValidator(message: string) {
  return ({}) => ({
    validator: (_, value) => {
      if (!value) {
        return Promise.resolve(); // Skip validation if the field is empty
      }
      
      const expr = new RegExp(/^[A-Za-z0-9][A-Za-z0-9\s-]{1,9}$/, "i");

      if (typeof value.trim === "function") {
        // trim value if it is a string
        value = value.trim();
      }

      if (expr.test(value)) {
        return Promise.resolve();
      } else {
        return Promise.reject(new Error(message));
      }
    },
  });
}
